"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterManipulator = exports.HeaderManipulator = exports.HeaderFooterManipulatorBase = void 0;
var tslib_1 = require("tslib");
var header_created_1 = require("../changes/model/header-created");
var header_footer_index_changed_1 = require("../changes/model/header-footer-index-changed");
var enums_1 = require("../enums");
var header_footer_history_items_1 = require("../history/items/header-footer-history-items");
var base_manipulator_1 = require("./base-manipulator");
var HeaderFooterManipulatorBase = (function (_super) {
    tslib_1.__extends(HeaderFooterManipulatorBase, _super);
    function HeaderFooterManipulatorBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderFooterManipulatorBase.prototype.createObject = function (type) {
        var object = this.createObjectCore();
        object.headerFooterType = type;
        var objectIndex = this.getObjectsCache().push(object) - 1;
        this.modelManipulator.notifyModelChanged(new header_created_1.HeaderFooterCreatedModelChange(this.isHeader(), type, object));
        return objectIndex;
    };
    HeaderFooterManipulatorBase.prototype.changeObjectIndex = function (sectionIndex, type, objectIndex) {
        this.modelManipulator.notifyModelChanged(new header_footer_index_changed_1.HeaderFooterIndexChangedModelChange(sectionIndex, this.isHeader(), type, objectIndex));
        var section = this.modelManipulator.model.sections[sectionIndex];
        var oldIndex = this.getContainer(section).getObjectIndex(type);
        this.getContainer(section).setObjectIndex(type, objectIndex);
        return oldIndex;
    };
    HeaderFooterManipulatorBase.prototype.insertHeaderFooter = function (sectionIndex, isHeader, type) {
        this.modelManipulator.batchUpdatableObject.beginUpdate();
        var objectIndex = this.getHeaderFooterManipulator(isHeader).createObject(type);
        this.history.addAndRedo(new (isHeader ? header_footer_history_items_1.ChangeHeaderIndexHistoryItem : header_footer_history_items_1.ChangeFooterIndexHistoryItem)(this.modelManipulator, sectionIndex, type, objectIndex, function (_oldIndex) { }));
        this.modelManipulator.batchUpdatableObject.endUpdate();
    };
    HeaderFooterManipulatorBase.prototype.getHeaderFooterManipulator = function (isHeader) {
        return isHeader ? this.modelManipulator.header : this.modelManipulator.footer;
    };
    return HeaderFooterManipulatorBase;
}(base_manipulator_1.BaseManipulator));
exports.HeaderFooterManipulatorBase = HeaderFooterManipulatorBase;
var HeaderManipulator = (function (_super) {
    tslib_1.__extends(HeaderManipulator, _super);
    function HeaderManipulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderManipulator.prototype.createObjectCore = function () {
        return this.modelManipulator.model.createSubDocument(enums_1.SubDocumentInfoType.Header, -1).info;
    };
    HeaderManipulator.prototype.getObjectsCache = function () {
        return this.modelManipulator.model.headers;
    };
    HeaderManipulator.prototype.isHeader = function () {
        return true;
    };
    HeaderManipulator.prototype.getContainer = function (section) {
        return section.headers;
    };
    return HeaderManipulator;
}(HeaderFooterManipulatorBase));
exports.HeaderManipulator = HeaderManipulator;
var FooterManipulator = (function (_super) {
    tslib_1.__extends(FooterManipulator, _super);
    function FooterManipulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FooterManipulator.prototype.createObjectCore = function () {
        return this.modelManipulator.model.createSubDocument(enums_1.SubDocumentInfoType.Footer, -1).info;
    };
    FooterManipulator.prototype.getObjectsCache = function () {
        return this.modelManipulator.model.footers;
    };
    FooterManipulator.prototype.isHeader = function () {
        return false;
    };
    FooterManipulator.prototype.getContainer = function (section) {
        return section.footers;
    };
    return FooterManipulator;
}(HeaderFooterManipulatorBase));
exports.FooterManipulator = FooterManipulator;
